// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"86765bffc6de3bc5212b","655":"ed1e90a2980c0fb43e8c"}[chunkId] + ".js";
};